import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TokenService } from '../services/token.service';
import { IntegrationService } from '../services/integration.service';
import { Injectable } from '@angular/core';
import { CoreService } from '@charlesschwab/sac-ui-core';

@Injectable()
export class AipInterceptor implements HttpInterceptor {
  constructor(
    private tokenService: TokenService,
    private integrationService: IntegrationService,
    private coreService: CoreService
  ) {}

  private guid = () => {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  };

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.includes('SsoInitiatorOAuth') || request.url.includes(this.integrationService.getApplicationPath())) {
      return next.handle(request);
    }
    const accept = request.headers.get('Accept');
    const contentType = request.headers.get('Content-Type');

    var firmId = this.coreService.currentContext.firmId;

    request = request.clone({
      setHeaders: {
        'Schwab-Client-FirmId': firmId.toString(),
        'Schwab-Client-CorrelId': this.guid(),
        'Schwab-Resource-Version': '1',
        'Schwab-Client-AppId': 'AD00002259',
        'Schwab-Client-Channel': 'S3',
        'Content-Type': contentType ?? 'application/json',
        Accept: accept ?? 'application/json'
      }
    });
    return next.handle(request);
  }
}
